module.exports = __webpack_public_path__ + "img/temp-aircon-on.09f72809.svg";